import BaseSchema from "./base-schema";

class OrderStatusUpdated extends BaseSchema {
  constructor(data) {
    super("orderStatusUpdated", 6, 'gfr', data);
  }

  getData({ confirmedOrder, initialPrepMins, prepMins }) {
    const CONFIRMED_STATUS = "CONFIRMED";
    const FIRED_FROM = "CES-UI_FOOD-PREP-TIME-MODAL";

    const orderUuid = confirmedOrder.order.uuid;
    const statusVersionUuid = confirmedOrder.order.statusVersionUuid;
    const merchantOrderVersion = confirmedOrder.order.merchantOrderVersion;
    const shortMerchantId = confirmedOrder.order.shortMerchantId;

    return {
      orderUuid: orderUuid,
      orderStatus: CONFIRMED_STATUS,
      orderIdSnapshot: {
        "gfr.orderIdSnapshot": {
          orderUuid: orderUuid,
          orderApiHash: statusVersionUuid
            ? { string: statusVersionUuid }
            : null,
          orderMosHash: merchantOrderVersion
            ? { string: merchantOrderVersion }
            : null,
          restaurantId: merchantOrderVersion
            ? { string: shortMerchantId }
            : null,
        },
      },
      defaultEstimate: { int: initialPrepMins },
      userEnteredEstimate: { int: prepMins },
      firedFrom: { string: FIRED_FROM },
      suggestedEstimate: null,
      isBYOD: false,
    };
  }
}

export default OrderStatusUpdated;



// WEBPACK FOOTER //
// ./client/app/common/clickstream/schemas/order-status-updated-schema.js